module.exports = __webpack_public_path__ + "static/media/is_acs_system.4b01f6d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/is_acs_system.svg
// module id = 1521
// module chunks = 0